import React, { FC } from 'react'

import { Grid, Paper, Typography } from '@mui/material'
import Title from '../Title'

import { Counter } from './ContractTests'

interface TestInfoCardProps {
  counter: Counter
}
const TestInfoCard: FC<TestInfoCardProps> = ({ counter }) => {
  return (
    <Grid item xs={12} md={3} lg={3}>
      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <Title>Tests count for choosen period:</Title>
        <div>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Questions
          </Typography>
          <Typography component="p" variant="subtitle2" mb={2} sx={{ flex: 1 }}>
            Scheduled: {counter.questionsScheduled} <br />
            Completed: {counter.questionsCompleted}
          </Typography>
        </div>
        <div>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            2MWT
          </Typography>
          <Typography component="p" variant="subtitle2" mb={2} sx={{ flex: 1 }}>
            Scheduled: {counter.walkingScheduled} <br />
            Completed: {counter.walkingCompleted}
          </Typography>
        </div>
        <div>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            SDMT
          </Typography>
          <Typography component="p" variant="subtitle2" mb={2} sx={{ flex: 1 }}>
            Scheduled: {counter.sdmtScheduled} <br />
            Completed: {counter.sdmtCompleted}
          </Typography>
        </div>
      </Paper>
    </Grid>
  )
}
export default TestInfoCard
